import React, { useMemo } from "react";
import PropTypes from "prop-types";
const ProgressBar = ({
  percentage = 0,
  showInformation = false,
  information = "Cargando",
}) => {
  const progress = useMemo(() => {
    return Math.max(0, Math.min(percentage, 100));
  }, [percentage]);

  return (
    <div className="w-full my-2">
      <div className="w-full bg-gray-300 rounded-full">
        <div
          className="bg-green-500 h-2.5 rounded-full transition-all duration-100 ease-in-out"
          style={{
            width: `${progress}%`,
          }}
        ></div>
      </div>
      {showInformation ? (
        <span className="text-sm font-semibold">
          {information} {progress}%
        </span>
      ) : null}
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number,
  showInformation: PropTypes.bool,
  information: PropTypes.string,
};
export default ProgressBar;
